module.exports = __webpack_public_path__ + "static/img/service_safeguard_end_3.0b500ebd.png";